import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Matcher } from "react-day-picker";
import moment from "moment";
import { Calendar } from "../Calendar";

interface IDatePickerFilterProps {
    selectedDate: Date | undefined;
    onDateChange: (date: Date | undefined) => void;
    minDate?: Date;
    maxDate?: Date;
    placeholder?: string;
    disabled?: boolean;
}

const DatePickerFilter = ({
    selectedDate,
    onDateChange,
    minDate,
    maxDate,
    placeholder = "Pilih Tanggal",
    disabled = false,
}: IDatePickerFilterProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const formatDateLabel = () => {
        if (!selectedDate) return placeholder;
        return moment(selectedDate).format("DD MMMM YYYY");
    };

    const handleDateSelect = (date: Date | undefined) => {
        if (date) {
            onDateChange(date);
            setAnchorEl(null);
        }
    };

    const getDisabled = (): Matcher | Matcher[] => {
        if (minDate && maxDate) return [{ before: minDate }, { after: maxDate }];
        if (minDate) return { before: minDate };
        if (maxDate) return { after: maxDate };
        return { after: new Date() };
    };

    return (
        <Box width="100%">
            <Button
                variant="outlined"
                fullWidth
                disabled={disabled}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                startIcon={
                    <CalendarTodayRoundedIcon htmlColor="rgba(0, 0, 0, 0.6)" />
                }
                sx={{
                    justifyContent: "space-between",
                    borderColor: "rgba(0, 0, 0, 0.23)",
                    textTransform: "none",
                    width: "100%",
                    height: "40px",
                    color: "text.primary",
                    paddingRight: 1,
                }}
            >
                <Typography color="text.primary">
                    {formatDateLabel()}
                </Typography>
                <ArrowDropDownIcon htmlColor="rgba(0, 0, 0, 0.6)" />
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                onClose={() => setAnchorEl(null)}
                PaperProps={{
                    sx: {
                        p: 2,
                        borderRadius: 2,
                        maxWidth: "90vw",
                    },
                }}
            >
                <Calendar
                    mode="single"
                    selected={selectedDate}
                    onSelect={handleDateSelect}
                    disabled={getDisabled()}
                />
            </Popover>
        </Box>
    );
};

export default DatePickerFilter;
